import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ITransition } from '../../models/workflow-builder.model';
import { COMPARATORS } from '../../core/catalogs';

/** Decision diamond: ◆ IF + compound AND-clauses. Click opens the sidebar to edit. */
@Component({
  selector: 'irembogov-iwb-condition-node',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="condnode" (click)="configure.emit()">
      <div class="diamondbig"></div>
      <div class="condclauses">
        <div class="cch">Condition</div>
        <ng-container *ngFor="let c of clauses; let i = index">
          <div class="andbar" *ngIf="i > 0">AND</div>
          <div class="clause">
            <span class="p">{{ c.parameter }}</span
            ><span class="op">{{ label(c.comparator) }}</span
            ><span class="v">{{ c.value }}</span>
          </div>
        </ng-container>
        <div class="cedit">click to edit in sidebar</div>
      </div>
    </div>
  `,
})
export class ConditionNodeComponent {
  @Input() transition!: ITransition;
  @Output() configure = new EventEmitter<void>();

  get clauses() {
    return this.transition.guard ? this.transition.guard.clauses : [];
  }
  label(code: string): string {
    const c = COMPARATORS.find(x => x.code === code);
    return c ? c.label : code;
  }
}
